module.exports = __webpack_public_path__ + "img/70-r.323deab3.png";